export default __webpack_public_path__ + "static/media/stolle.80c45f94.png";